import axios from "axios";
import { FEEDBACK } from "../endpointsConst";

const ContactUsService = {};

ContactUsService.sendMessage = (data) => axios.post(FEEDBACK, data);

export { ContactUsService };
